import { ACTION_TYPES } from '../constants';

export default url => ({
  type: ACTION_TYPES.FETCH_VOD_PATH_REQUEST,
  payload: {
    url
  }
});
